import { render, staticRenderFns } from "./NavettaAutista.vue?vue&type=template&id=3a91dbd2&scoped=true&"
import script from "./NavettaAutista.vue?vue&type=script&lang=js&"
export * from "./NavettaAutista.vue?vue&type=script&lang=js&"
import style0 from "./NavettaAutista.vue?vue&type=style&index=0&id=3a91dbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91dbd2",
  null
  
)

export default component.exports